import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main-grid"
}
const _hoisted_2 = {
  key: 0,
  class: "header-area header-grid"
}
const _hoisted_3 = {
  key: 1,
  class: "sidebar-area"
}
const _hoisted_4 = { class: "content-area" }
const _hoisted_5 = { class: "footer-area footer-grid" }
const _hoisted_6 = { class: "footer-left-area" }
const _hoisted_7 = { class: "footer-right-area" }

import Sidebar from './components/Sidebar.vue'
import { authStore } from '@/stores/auth'
import HeaderBar from '@/components/HeaderBar.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const auth = authStore()
const screenWidth = computed(() => window.innerWidth)
const route = useRoute()
const appVersion = computed(() => process.env.VUE_APP_VERSION)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(auth).loggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(screenWidth) <= 1024)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(HeaderBar)
            ]))
          : _createCommentVNode("", true),
        (_unref(screenWidth) > 1024)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(Sidebar)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()) + " - Tuvast Huurdersportaal.", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, "v" + _toDisplayString(_unref(appVersion)), 1)
          ])
        ])
      ]))
    : (!_unref(auth).loggedIn && ['Login', 'ForgotPassword', 'ChangePassword'].includes(_unref(route).name))
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : _createCommentVNode("", true)
}
}

})